export default __webpack_public_path__ + "static/media/discipline2.c09d97b2.png";